import React, { useState, useEffect, useMemo } from "react";
import { ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import kkKZ from "antd/locale/kk_KZ";
import enUS from "antd/locale/en_US";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/kk";
import "dayjs/locale/en";
import "./App.css";
import { Router } from "../routes";
import { User, UserContext } from "../../shared/contexts";
import { LanguageContext } from "../../shared/contexts/LanguageContext";
import { Language } from "../../shared/translations";
import { getToken, getFirstName, getLastName } from "../../shared/app";

const ANTD_LOCALES = {
  ru: ruRU,
  kk: kkKZ,
  en: enUS,
} as const;

const DAYJS_LOCALES: Record<Language, string> = {
  ru: "ru",
  kk: "kk",
  en: "en",
};

export function App() {
  const [user, setUser] = useState<User | null>(null);
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('language');
    return (saved as Language) || 'ru';
  });

  // Восстанавливаем токен и данные пользователя из localStorage при загрузке приложения
  useEffect(() => {
    const token = getToken();
    if (token) {
      const firstName = getFirstName();
      const lastName = getLastName();
      setUser({
        token,
        firstName: firstName || undefined,
        lastName: lastName || undefined
      });
    }
  }, []);

  // Переключаем глобальную локаль dayjs СИНХРОННО с UI-языком (во время рендера,
  // а не в useEffect), чтобы Ant Design DatePicker/Calendar при первом же рендере
  // после смены языка отображали названия дней и месяцев на выбранном языке,
  // а не дефолтном английском. useMemo гарантирует, что dayjs.locale выставлен
  // до того, как отрендерятся дочерние antd-компоненты.
  const antdLocale = useMemo(() => {
    dayjs.locale(DAYJS_LOCALES[language] || 'ru');
    return ANTD_LOCALES[language] || ruRU;
  }, [language]);

  return (
    <div className="App">
      <ConfigProvider locale={antdLocale}>
        <LanguageContext.Provider value={{ language, setLanguage }}>
          <UserContext.Provider value={{ user, setUser }}>
            <Router />
          </UserContext.Provider>
        </LanguageContext.Provider>
      </ConfigProvider>
    </div>
  );
}
